export function reloadApp() {
  window.location.href = '/app';
}
